const home = {
  avt: require('../assets/avatar.png'),
  avtNCM: require('../assets/avatar-opt.webp'),
  logoColor: require('../assets/logo.webp'),
  logoWhite: require('../assets/logo-white.webp')
}

export const Images = {
  home
}
